module.exports = __webpack_public_path__ + "img/9788958172390.79f60b30.jpg";